import React from "react"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

const StyledTypography = styled(Typography)({
  color: "#ffffff",
  fontSize: "12px",
  textDecoration: "none",
  "&:hover": {
    color: "#ffffff",
    textDecoration: "underline",
  },
})

const FooterText = (props) => {
  return <StyledTypography>{props.children}</StyledTypography>
}

export default FooterText
